import React, { Component } from 'react';

class Callback extends Component {
    render(){
        if(this.props.visible){
            return(
                <div className="call-back">
                    <h2>Call back</h2>
                    <p>Leave your phone number. And we call you</p>
                    <div className="vb-tel">
                        <input type="tel" placeholder="Phone number" />
                        <input type="submit" value="Send" />
                    </div>
                </div>
            )
        }else{
            return false;
        }        
    }
}

export default Callback;